import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "review-and-approval"
    }}>{`Review and Approval`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`With the COVID-19 pandemic came the immediate challenge to support remote workers. Teams and cross-functional groups need ways to share ideas and information, collaborate, and review digital documents. These end-user workflows often require an approval process to create final assets. However, not all users have access to the applications needed to view the various file formats. Additionally, teams often exchange feedback via manual methods, such as email and live meetings.`}</p>
    <p>{`Adobe Acrobat Services lets teams:`}</p>
    <ul>
      <li parentName="ul">{`Standardize document files into a common format (PDF)`}</li>
      <li parentName="ul">{`Enable annotation, commenting, markup and more`}</li>
      <li parentName="ul">{`Create end-to-end workflows, from providing feedback on drafts to approving final content`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A company is trying to launch a new product, but teams are distributed across the globe and there are documents in many formats, including Microsoft Word docs, JPEG files, and InDesign and Illustrator files. The project lead wants to gather feedback from a number of people, and then key stakeholders need to approve the content. With the launch just weeks away, the process needs to be as automated as possible to ensure broad feedback but also to meet tight deadlines.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Using Adobe PDF Services API, create PDFs from multiple file formats (Word, JPEG, InDesign, and Illustrator)`}</li>
      <li parentName="ol">{`Display the PDF document with a custom viewing mode using the free Adobe PDF Embed API`}</li>
      <li parentName="ol">{`Enable annotations and commenting with callbacks in Adobe PDF Embed API`}</li>
      <li parentName="ol">{`Setup identification of users by name using custom callbacks in Adobe PDF Embed API`}</li>
      <li parentName="ol">{`Optionally implement controls to save ongoing edits to local or external storage for multi-user workflows`}</li>
      <li parentName="ol">{`After a draft is approved, Adobe PDF Services API Create PDF operation can be used to generate the final asset`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      